import React from 'react';
import Label1 from "../../../../reusableComponents/InputFields/Label1";
import { useAuth } from "../../../../../context/AuthContext";

const AddressInformationComponent = () => {
    const { currentUser } = useAuth();
    
    // Sample data - replace with actual data from user context
    const streetAddress = currentUser?.address?.street || "";
    const city = currentUser?.address?.city || "";
    const state = currentUser?.address?.state || "";
    const zipCode = currentUser?.address?.zipCode || "";
    const country = currentUser?.address?.country || "";

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-x-12 sm:gap-y-6 p-2 sm:p-0">
            {/* Address field */}
            <Label1
                label="Street Address"
                placeholder={streetAddress}
                className="col-span-1 sm:col-span-2 w-full"
                disabled={true}
                showLeftIcon={false}
                showRightIcon={false}
                showSupportingText={false}
            />
            
            {/* City and State */}
            <Label1
                label="City"
                placeholder={city}
                className="w-full"
                disabled={true}
                showLeftIcon={false}
                showRightIcon={false}
                showSupportingText={false}
            />
            <Label1
                label="State/Province"
                placeholder={state}
                className="w-full"
                disabled={true}
                showLeftIcon={false}
                showRightIcon={false}
                showSupportingText={false}
            />
            
            {/* ZIP Code and Country */}
            <Label1
                label="ZIP Code"
                placeholder={zipCode}
                className="w-full"
                disabled={true}
                showLeftIcon={false}
                showRightIcon={false}
                showSupportingText={false}
            />
            <Label1
                label="Country"
                placeholder={country}
                className="w-full"
                disabled={true}
                showLeftIcon={false}
                showRightIcon={false}
                showSupportingText={false}
            />
        </div>
    );
};

export default AddressInformationComponent;